import { FormControl, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDropdownFormControl = styled(FormControl, {
  shouldForwardProp: (prop) => prop !== 'isLeftIcon',
})<{
  isLeftIcon: boolean;
}>(({ theme, isLeftIcon }) => ({
  '& .MuiFilledInput-root': {
    border: `0px solid ${theme.palette.divider}`,
    overflow: 'hidden',
    borderRadius: theme.spacing(6),
    backgroundColor: 'transparent',
    paddingLeft: isLeftIcon ? undefined : theme.spacing(6),
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:disable': {
      backgroundColor: 'transparent',
    },
    '&.Mui-focused': {
      backgroundColor: 'transparent',
      borderColor: theme.palette.divider,
    },
    '& .MuiInputLabel-root': {
      '&.Mui-error': {
        color: 'red',
      },
    },
  },
  '& .MuiSelect-multiple': {
    display: 'flex',
    gap: theme.spacing(2)
  },
  '& .MuiInputBase-root.Mui-disabled': {
    backgroundColor: 'transparent',
  },
  '& .MuiSelect-select:focus': {
    backgroundColor: 'transparent',
  },
  '& label': {
    maxWidth: 'calc(100% - 40px)',
  },
}));

export const DropdownContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'error',
})<{ error: boolean }>(({ theme, error }) => ({
  display: 'flex',
  border: `1px solid ${
    error ? theme.palette.error.main : theme.palette.divider
  }`,
  borderRadius: theme.spacing(6),
  flexDirection: 'row',
  alignItems: 'center',
}));

export const LeftIconBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  paddingLeft: theme.spacing(6),
}));
